import { render, staticRenderFns } from "./EducationMainPage.vue?vue&type=template&id=7556ac66"
import script from "./EducationMainPage.vue?vue&type=script&lang=js"
export * from "./EducationMainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports